module.exports = __webpack_public_path__ + "img/ico-eu_BIG.15f1b3fc.png";